var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"inline-flex rounded-md shadow-sm"},[_c('router-link',{class:_vm.btnClass,attrs:{"to":_vm.to,"type":"button"}},[_c('span',[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }